"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var SimpleExampleIcon_1 = require("./SimpleExampleIcon");
var StylingExampleIcon_1 = require("./StylingExampleIcon");
var PropertiesIcon_1 = require("./PropertiesIcon");
var Icons_1 = require("./Icons");
exports.ComponentIconPage = function () { return (React.createElement(common_1.Page, { headerText: "Icon" },
    React.createElement(common_1.Paragraph, null, "Floating Action Button, or simply Icon, is used as a main action in a view."),
    React.createElement(common_1.TopicHeader, null, "Icons"),
    React.createElement(Icons_1.Icons, null),
    React.createElement(common_1.TopicHeader, null, "Examples"),
    React.createElement(SimpleExampleIcon_1.SimpleExampleIcon, null),
    React.createElement(StylingExampleIcon_1.StylingExampleIcon, null),
    React.createElement(common_1.TopicHeader, null, "Properties"),
    React.createElement(PropertiesIcon_1.PropertiesIcon, null))); };
exports.ComponentIconPage.displayName = 'ComponentIconPage';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentIconPage/ComponentIconPage.tsx
// module id = 683
// module chunks = 0